import React, {useEffect, useState } from 'react'
import "./AdProductEdit.css"
import './CheckoutProduct.css'
import dataCarts from './dataCarts'
import { useStateValue } from './StateProvider';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

function AdProductEdit() {
  const [{ basket, productDetalis, admnavagationoption }, dispatch] = useStateValue();
  const [product, setProduct] = useState([]);
  const [id, setId] = useState('')
  const [title, setTitle] = useState('');
  const [price, setPrice] = useState('');
  const [img, setImg] = useState('');
  const [weigth, setWeigth] = useState('');
  const [dimensions, setDimensions] = useState('');
  const [searching_words, setSearching_words] = useState('');
  const history = useHistory();
  const [oldtitle, setOldtitle] = useState('');
  const [respo, setRespo] = useState('');

  const hdone = () =>{

    axios
          .get('https://toycityzimbabwe.com/backend/updateProdut.php', {params: {id, title, price, searching_words}})
          .then(res => {
            if(res.data === 'Update Sucessfully')
            {
              spacs();
            }else{
              setRespo('Update Failed '+ res.data)
            }
            
          })
          .catch( error => {
              console.log(error)
          });

    dispatch({
      type: 'SET_ADMNO',
      admnavagationoption: 'two'
    })
  }

  const spacs = () => {

    axios
          .get('https://toycityzimbabwe.com/backend/updateProdutSpecs.php', {params: {oldtitle, title, weigth, dimensions}})
          .then(res => {
            if(res.data === 'Update Sucessfully')
            {
              setRespo('Update Sucessfully');
            }else{
              setRespo('Update Failed '+ res.data);
            }            
          })
          .catch( error => {
              console.log(error)
          });

    history.push('/Admin14F-efghS=workApp/filesManagement-Wdf17/Admin');
  }

  const hclose = () => {

    dispatch({
      type: 'SET_ADMNO',
      admnavagationoption: 'two'
    })

    history.push('/Admin14F-efghS=workApp/filesManagement-Wdf17/Admin');
  }

  useEffect(() => {
    productDetalis.map(item =>{
      setId(item.id)
      setTitle(item.title)
      setPrice(item.price)
      setImg(item.img);
      setOldtitle(item.title);
      setSearching_words(item.searching_words);

      axios
          .get('https://toycityzimbabwe.com/backend/getSpecs.php', {params: {name: item.title}})
          .then(res => {
            setProduct(res.data)
          })
          .catch( error => {
              console.log(error)
          });
    })

    dispatch({
      type: 'SET_ADMNO',
      admnavagationoption: 'two'
    })
    
      
  }, []);

  useEffect(() => {
    product.map(item => {
      setWeigth(item.pdescription);
      setDimensions(item.dimension);
    })
    
  }, [product])

  const [slideIndex, setSlideIndex] = useState(1);

  useEffect(() => {
    const lastIndex = dataCarts.length
    
    if(slideIndex < 1){
        setSlideIndex(lastIndex)
    }

    if( slideIndex > lastIndex){
        setSlideIndex(1)
    }
  }, [slideIndex])

  useEffect(() => {
    let slider = setInterval(() => {
        setSlideIndex(slideIndex + 1)
    }, 5000);
    return () => clearInterval(slider)
  }, [slideIndex])

  const moveDot = index => {
    setSlideIndex(index)
  }

  return (
    <div className="container-carts">
        <div className="container-btn">
            <button className='x-btn' onClick={hclose}>X</button>
        </div>
      <div className='details-cont'>
        {product.map((obj, index) => {
          
              return (
                  <div
                  key={obj.id}
                  className={slideIndex === index + 1 ? "slide active-anim" : "slide"}
                  >
                      <img 
                        src={obj.product_img} 
                      />
                  </div>
                )
          })}
          <div className="container-cartdots">
            {product.map((item, index) => (
                <div 
                  onClick={() => moveDot(index + 1)}
                  className={slideIndex === index + 1 ? "cartdot active" : "cartdot"}
                  
                >
                  <img 
                        src={item.product_img} 
                  />
                </div>
            ))}
          </div>
      </div>
      
      <div className='carts-details'>
          <p><input type='text' value={title} onChange={e => setTitle(e.target.value)} /></p>
          <h2><div className='price-display'>
                
            <input type='text' value={price} onChange={e => setPrice(e.target.value)} />
                   
            </div></h2>
      </div>
      <h3>Specifications</h3>
      <div className='specs-cont'>
        <table>
          <tr>
            <th>Description:</th>
            <td><textarea value={weigth} onChange={e => setWeigth(e.target.value)} rows="8" cols="100" /></td>
          </tr> 
          <tr> 
            <th>Dimensions:</th>
            <td><input type='text' value={dimensions} onChange={e => setDimensions(e.target.value)} /></td>
          </tr>
          <tr> 
            <th>Searching Words:</th>
            <td><input type='text' value={searching_words} onChange={e => setSearching_words(e.target.value)} /></td>
          </tr>
        </table>  
      </div>
      <div className="container-btn">
        <button className='c-btn' onClick={hdone}>Update</button>
      </div>
      <div className='container__sms gender__sms'>
        {respo}
      </div>
    </div>
  )
}

export default AdProductEdit;